// extracted by mini-css-extract-plugin
module.exports = {"icon":"switchTabs_icon__2-fQz"};